import styled from '@emotion/styled';
import { H1, H2, Text } from 'ds/components/typography';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Title = styled(H1)`
  font-size: 32px;
  line-height: 38px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    font-size: 64px;
    line-height: 77px;
  `}
`;

export const Subtitle = styled(H2)`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  font-size: 24px;
  line-height: 29px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    font-size: 56px;
    line-height: 67px;
  `}
`;

export const Description = styled(Text)`
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  font-size: 15px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutrals.grey2};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    max-width: 776px;
    font-size: 21px;
    line-height: 32px;
  `}
`;

export const TagsRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;
  align-self: center;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing(3)};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    flex-direction: row;
  `}
`;

export const Tags = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5, 1)};
  flex-wrap: wrap;
  justify-content: center;
`;
